import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import RouteURL from '~routes'
import Icon from '~components/Icon'

import * as style from './BlockassetLogo.module.scss'

const BlockassetLogo = (props) => {
  const { className, variant, ...rest } = props

  return (
    <Link
      to={RouteURL.ASSET_HUB}
      {...rest}
      className={classNames(
        style.blockassetLogo,
        { [style[variant]]: variant },
        className
      )}
    >
      <Icon
        name="icon-blockasset-logo"
        isFromInlineDefs
        size={['100%', 'auto']}
        viewbox={[351.6, 406]}
      />
      <svg
        width="100%"
        viewBox="0 0 88 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={style.textBlockasset}
      >
        <path
          d="M0.08 14H2.942V12.938H2.978C3.356 13.658 4.436 14.342 5.84 14.342C8.378 14.342 10.88 12.542 10.88 8.942C10.88 5.162 8.054 3.668 5.966 3.668C5.552 3.668 4.13 3.668 3.068 4.802V0.68H0.08V14ZM2.96 8.978C2.96 7.736 3.86 6.458 5.444 6.458C6.92 6.458 7.892 7.7 7.892 8.996C7.892 10.31 6.92 11.552 5.39 11.552C3.896 11.552 2.96 10.364 2.96 8.978ZM10.9405 14H13.9285V0.68H10.9405V14ZM14.0029 8.996C14.0029 11.444 15.7489 14.306 19.3849 14.306C23.0209 14.306 24.7669 11.444 24.7669 8.996C24.7669 6.548 23.0209 3.686 19.3849 3.686C15.7489 3.686 14.0029 6.548 14.0029 8.996ZM16.9909 8.996C16.9909 7.538 18.0889 6.476 19.3849 6.476C20.6809 6.476 21.7789 7.538 21.7789 8.996C21.7789 10.454 20.6809 11.516 19.3849 11.516C18.0889 11.516 16.9909 10.454 16.9909 8.996ZM31.8951 10.202C31.5711 10.814 30.9771 11.534 29.7351 11.534C28.3131 11.534 27.3591 10.454 27.3591 8.996C27.3591 7.556 28.3131 6.386 29.7351 6.458C30.9771 6.458 31.5711 7.178 31.8951 7.862H34.9191C34.4151 5.414 32.2731 3.668 29.6271 3.668C26.6391 3.668 24.3531 6.044 24.3531 8.978C24.3531 11.948 26.6751 14.324 29.6991 14.324C32.3991 14.324 34.3971 12.47 34.9371 10.202H31.8951ZM35.0693 14H38.0573V9.194H38.0933L40.9193 14H44.3033L40.6493 8.402L44.4113 4.01H40.8653L38.0933 7.628H38.0573V0.68H35.0693V14ZM54.4701 4.01H51.4821V5.072H51.4461C51.0861 4.46 50.1681 3.668 48.5301 3.668C45.8661 3.668 43.5081 5.72 43.5081 8.996C43.5081 11.858 45.3621 14.342 48.5301 14.342C49.7001 14.342 50.9421 13.892 51.4461 12.92H51.4821V14H54.4701V4.01ZM46.4961 9.032C46.4961 7.898 47.2521 6.458 48.9621 6.458C50.6541 6.458 51.4821 7.79 51.4821 8.996C51.4821 9.968 50.8521 11.552 48.9801 11.552C47.1801 11.552 46.4961 9.968 46.4961 9.032ZM62.2119 6.818C61.9599 4.19 59.6919 3.668 58.3779 3.668C56.3079 3.668 54.5079 4.982 54.5079 6.962C54.5079 8.312 55.5879 9.158 56.8839 9.572C58.7919 10.31 59.5299 10.4 59.5299 11.174C59.5299 11.66 58.9899 11.948 58.4859 11.948C58.3599 11.948 57.4779 11.948 57.3519 11.03H54.3819C54.6519 13.658 56.9379 14.342 58.4499 14.342C60.6639 14.342 62.5179 13.046 62.5179 10.94C62.5179 8.78 60.7179 8.276 59.0259 7.808C58.2339 7.574 57.4959 7.268 57.4959 6.728C57.4959 6.458 57.7119 6.062 58.3419 6.062C59.2239 6.062 59.2599 6.602 59.2779 6.818H62.2119ZM69.5743 6.818C69.3223 4.19 67.0543 3.668 65.7403 3.668C63.6703 3.668 61.8703 4.982 61.8703 6.962C61.8703 8.312 62.9503 9.158 64.2463 9.572C66.1543 10.31 66.8923 10.4 66.8923 11.174C66.8923 11.66 66.3523 11.948 65.8483 11.948C65.7223 11.948 64.8403 11.948 64.7143 11.03H61.7443C62.0143 13.658 64.3003 14.342 65.8123 14.342C68.0263 14.342 69.8803 13.046 69.8803 10.94C69.8803 8.78 68.0803 8.276 66.3883 7.808C65.5963 7.574 64.8583 7.268 64.8583 6.728C64.8583 6.458 65.0743 6.062 65.7043 6.062C66.5863 6.062 66.6223 6.602 66.6403 6.818H69.5743ZM76.3248 10.868C75.9108 11.39 75.4248 11.804 74.5068 11.804C73.3368 11.804 72.3468 11.102 72.1668 9.914H79.6548C79.6908 9.68 79.7268 9.518 79.7268 9.122C79.7268 6.08 77.4948 3.668 74.4528 3.668C71.4108 3.668 69.2148 6.242 69.2148 9.032C69.2148 12.002 71.6448 14.324 74.5068 14.324C75.5328 14.324 76.5228 14.018 77.3508 13.424C78.1968 12.848 78.8988 11.984 79.3848 10.868H76.3248ZM72.2028 7.898C72.3288 7.304 72.9228 6.188 74.4708 6.188C76.0188 6.188 76.6128 7.304 76.7388 7.898H72.2028ZM83.3535 0.68H80.3655V4.01H78.8895V6.278H80.3655V14H83.3535V6.278H84.7935V4.01H83.3535V0.68ZM87.774 10.94H84.66V14H87.774V10.94Z"
          fill="white"
        />
      </svg>
    </Link>
  )
}

BlockassetLogo.defaultProps = {
  className: '',
  variant: '',
}

BlockassetLogo.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
}

export default BlockassetLogo
